// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if ({"src_password_quality_ts":1,"giphy-sdk":1}[chunkId]) return "" + chunkId + ".js";
	// return url for filenames based on template
	return "" + chunkId + ".js";
};